import { Row, Col } from 'antd'

import _map from 'lodash/map'

import Title from 'components/Title'
import Icon from 'components/Icon'
import Link from 'components/Link'

import Styled from './styled'

const legals = [
  {
    name: 'การปฏิบัติตามมาตรา 95 แห่งพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562',
    file: '/assets/legals/Notice95.pdf',
  },
  {
    name: 'นโยบายคุ้มครองข้อมูลส่วนบุคคลสำหรับลูกค้า',
    file: '/assets/legals/นโยบายคุ้มครองข้อมูลส่วนบุคคลสำหรับลูกค้า.pdf',
  },
  {
    name: 'นโยบายคุ้มครองข้อมูลส่วนบุคคลสำหรับบุคคลภายนอก',
    file: '/assets/legals/นโยบายคุ้มครองข้อมูลส่วนบุคคลสำหรับบุคคลภายนอกซึ่งเป็นคู่ค้า ผู้ขาย หรือผู้ให้บริการ.pdf',
  },
  {
    name: 'นโยบายคุ้มครองข้อมูลส่วนบุคคลสำหรับผู้สมัครงาน',
    file: '/assets/legals/นโยบายคุ้มครองข้อมูลส่วนบุคคลสำหรับผู้สมัครงาน.pdf',
  },
  {
    name: 'นโยบายคุ้มครองข้อมูลส่วนบุคคลสำหรับกล้องวงจรปิด (CCTV)',
    file: '/assets/legals/นโยบายคุ้มครองข้อมูลส่วนบุคคลสำหรับกล้องวงจรปิด (CCTV).pdf',
  },
]

export default function Legal() {
  return (
    <Styled>
      <div className="container">
        <Title level={1}>นโยบายความเป็นส่วนตัว (Privacy Policy)</Title>

        <div className="legal-container">
          <Row
            gutter={[
              { xs: 16, md: 60 },
              { xs: 30, md: 60 },
            ]}
          >
            {_map(legals, (legal, index) => {
              return (
                <Col span={12} lg={6} key={index}>
                  <div className="legal-block">
                    <Link href={legal?.file} openNewTab>
                      <Icon.File className="icon-file" />
                    </Link>

                    <div className="legal-name">
                      <Link href={legal?.file} openNewTab>
                        <Title level={5}>{legal?.name}</Title>
                      </Link>
                    </div>
                  </div>
                </Col>
              )
            })}
          </Row>
        </div>
      </div>
    </Styled>
  )
}
